import { createTheme } from '@mui/material'
import { useMemo } from 'react'
import type { FasTheme } from './theme-provider'

export function useMuiTheme(theme: FasTheme) {
  return useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: theme.colors.primary[600],
          },
          secondary: {
            main: theme.colors.secondary[600],
          },
        },
        typography: {
          fontFamily: 'Open Sans',
        },
      }),
    [theme],
  )
}
